import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import WeaMenu from '../../../../../pc4public/portal/wea-menu/';

import E9LeftMenuTop4Email from './E9LeftMenuTop4Email';

@inject('portalThemeStore')
@observer
class E9LeftMenu extends React.Component {
    constructor(props) {
        super(props);
        this.onSelect = this.onSelect.bind(this);
        this.onModeChange = this.onModeChange.bind(this);
    }

    componentDidUpdate() {
        const {portalThemeStore} = this.props;
        portalThemeStore.onLoadLeftMenuCount();
    }

    render() {
        const {portalThemeStore} = this.props;
        const {themeInfo, leftMenuObj, leftMenuMode} = portalThemeStore;

        const {themeData = {}} = themeInfo;
        const {styleConfig = {}} = themeData;
        const {leftmenu = {}} = styleConfig;
        const fontSize = parseInt(leftmenu.titleFontSize || '12px');

        const {leftMenu = [], leftMenuSelected = {}, leftMenuType} = leftMenuObj;
        let _leftMenu = toJS(leftMenu);
        let _leftMenuSelected = toJS(leftMenuSelected);
        let _selectedKey = _leftMenuSelected.id;

        return (
            <div className="e9aside-container">
                <WeaMenu
                    mode={leftMenuMode}
                    needSwitch={true}
                    inlineWidth={197}
                    verticalWidth={61}
                    fontSize={fontSize}
                    datas={(leftMenuType == 'email' && leftMenuMode == 'inline') ? _leftMenu.slice(2) : _leftMenu}
                    defaultSelectedKey={_selectedKey}
                    onSelect={this.onSelect}
                    onModeChange={this.onModeChange}
                    addonBefore={leftMenuType == 'email' ? <E9LeftMenuTop4Email emailMenu={_leftMenu} onSelect={this.onSelect}/> : ''}
                    addonBeforeHeight={leftMenuType == 'email' ? 40 : 0}
                />
            </div>
        );
    }

    onSelect(key, item, type) {
        window.isPortalRender = true;

        // type=0表示正常点击菜单，type=1表示点击菜单后面的图标
        const {portalThemeStore} = this.props;
        if (type == 1 && item.id == '536-53606') {  // 邮件菜单，清空垃圾箱
            portalThemeStore.onClearEmail(item);
        } else if (type == 0 && (item.id === '536-53611'||item.id === '536-53610')) { //我的文件夹、我的标签菜单 不跳转路由,只title跳转路由
            
        } else {
            if (type == 1) {
                item.url = item.titleUrl;
            }
            if(item.url && item.url != ''&& item.infoId < 0 && item.url.indexOf("document") != '-1' && item.url.indexOf("secid=") != '-1') {
                const num = item.url.indexOf("secid=");
                item.url = item.url.slice(0, num) +  "menuid=" + item.infoId;
            }
            portalThemeStore.onLeftMenuSelectedChange(item);
            portalThemeStore.onLoadMain(item);
        }
    }

    onModeChange(leftMenuMode) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onLeftMenuModeChange(leftMenuMode);
    }
}

export default E9LeftMenu;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9LeftMenu.js